<template>
  <div class="infinite-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
    style="overflow:auto;bodrer:1px solid #e43" infinite-scroll-distance="1">

    <div class="content" >
      <div class="wraper_bg wallet">
        <div class="info">
          <div class="info_photo">
            <img :src="userinfo.img_url" alt="">
          </div>
          <div class="info_name">
            <p class="info_name_call">
              {{userinfo.wx_name?userinfo.wx_name:userinfo.name}}
            </p>
            <p class="info_name_uid">uid:{{userinfo.id}}</p>
          </div>
          <div class="info_balance">
            <div class="router-link" @click="showRecharge">
              钱包充值
            </div>
          </div>
        </div>
        <div class="info_under">
          <div class="info_under_price divide-line right-border">
            <h3 class="info_id">{{userinfo.count?userinfo.count:0}}</h3>
            <p>钱包余额</p>
          </div>
          <div class="info_under_card divide-line none">
            <h3 class="info_id">6</h3>
            <p>卡券</p>
          </div>
          <div class="info_under_recharge none">
            <h3 class="info_id">180</h3>
            <p>积分</p>
          </div>
        </div>
      </div>

      <div class="wallet_list">
        <div class="wallet_title">
          交易明细
          <div class="wallet_condition">近三个月</div>
        </div>

        <div class="wallet_list_item" v-for="(n,nindex) in lists">
          <div class="wallet_info">
            <div :class="[n.type?'icome':'expenditure','wallet_list_item_type']">{{n.type?'减少':'增加'}}</div>
            <div class="wallet_list_item_number">{{n.type?'-':'+'}}{{n.price}}</div>
          </div>
          <div class="wallet_other">
            <div class="wallet_list_item_date">
              {{n.date}}
            </div>
            <div class="wallet_list_item_balance">
              余额：{{n.balance}}
            </div>
          </div>
        </div>
        <p id="loadMore" v-show="droping">加载中...</p>
        <p id="loadMore" v-show="noMore">没有更多了</p>
      </div>

      <el-dialog title="钱包充值" :visible.sync="rechargeDialogVisible"  class="dialog">
        <!-- <el-input v-model="amount" placeholder="请输入充值金额（₱）"></el-input> -->
        <div class="amount-desc">此为充充充电子钱包余额</div>
        <!-- 充值金额选项 -->
        <LifeAmount v-model="amount" :list="balanceRules" size="22px" marginBottom="15px" />
        <div class="radio-area" v-if="configPayments && configPayments.length > 0">
          <el-radio-group
          v-model="payment"
          size="small"
          @change="handleRadioChange" >
            <el-radio
              class="radio-item"
              :label="item.code"
              v-for="item in configPayments"
              :key="item.code"
            >
              <img :src="item.icon || '../../static/images/'+item.name+'.png'" >
            </el-radio>
          </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer btn-area">
          <el-button @click="rechargeDialogVisible = false" class="btn">取 消</el-button>
          <el-button type="primary" @click="rechargemoney" class="btn">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
        <div>
          <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
            :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <navBar :idx="3"></navBar>
    </div>
  </div>

</template>
<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import navBar from '@/components/navBar';
  import vueQr from 'vue-qr'
  import LifeAmount from '@/components/life-amount.vue'

  export default {
    name: 'wallet',
    components: {
      navBar,
      vueQr,
      LifeAmount
    },
    data() {
      return {
        rechargeDialogVisible: false,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        userinfo: {},
        amount: '',
        payments: [],
        configPayments: [],
        payment: 'weixin',
        busy: false,
        droping: false,
        noMore: false,
        lists: [],
        page: 0,
        pageSize: 10
      }
    },
    computed: {
      balanceRules() {
        return this.$store.state.balanceRules
      }
    },
    mounted() {
      this.getUserInfo();
      this.getConfigPayments();
    },
    methods: {
      handleClose: function(done) {
        done();
      },
      loadMore() {
        this.busy = true;
        this.droping = true;
        let auth_token = localStorage.getItem('auth_token');
        if (auth_token) {
          this.page++;
          this.$api
            .request('Member/getBalanceRecords', {page: this.page, pageSize: this.pageSize})
            .then(({ data }) => {
              if (data.length <= 0 || data.length < this.pageSize) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
              data.forEach(item => {
                this.lists.push(item);
              });
              this.busy = false;
              this.droping = false;
            })
            .catch(error => {
              this.$message({
                message: error + "加载充值记录失败！",
                type: "warning"
              })
            });
        } else {
          this.busy = false;
          this.droping = false;
          this.noMore = true;
        }
      },
      getUserInfo() {
        this.$api
          .request('Member/getInfo', {})
          .then(({ data }) => {
            this.userinfo = data;
          })
          .catch(error => {
            this.$message({
              message: error+"获取用户信息失败！",
              type: "warning"
            })
          });
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.paySign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      // 获取配置的支付方式列表
      async getConfigPayments() {
        try {
          const { data } = await this.$api.request('System/init', {
            position: 1,
            client: this.$client
          })
          if (typeof data.config_payments == 'object' && Array.isArray(data.config_payments)) {
            this.$set(this, 'configPayments', data.config_payments)
            // 默认选择第一个支付方式
            if (this.configPayments.length > 0) {
              this.payment = this.configPayments[0].code
            }
          }
        } catch (error) {
          console.error('获取支付方式列表失败:', error)
        }
      },
      showRecharge() {
        // 如果没有选择支付方式，默认选择第一个
        if (!this.payment && this.configPayments.length > 0) {
          this.payment = this.configPayments[0].code
        }
        this.rechargeDialogVisible = true;
      },
      openUrl(url) {
        if (url) {
          window.open(url, '_blank');
        }
        this.$confirm("支付提示","",{
          iconClass: "el-icon-question",//自定义图标样式
            confirmButtonText: "支付完成",//确认按钮文字更换
            cancelButtonText: "取消",//取消按钮文字更换
            showClose: true,//是否显示右上角关闭按钮
            type: "warning",//提示类型  success/info/warning/error
        }).then((data) => {
          let auth_token = localStorage.getItem('auth_token');
          if (auth_token) {
            this.$router.push('/historycard');
          }
        }).catch((err) => {

        });
      },
      rechargemoney() {
        // let exp = /^[1-9]\d*$/;
        // if (!exp.test(this.amount)) {
        //   this.$message({
        //     message: "请输入正确的金额！",
        //     type: "warning"
        //   })
        //   return;
        // }
        if (!this.amount) {
          this.$message({
            message: "请选择充值金额！",
            type: "warning"
          })
          return
        }
        this.rechargeDialogVisible = false;
        let settlement = 1;
        if (this.$client == 'wxh5' || (this.$client == 'h5' && this.payment == 'weixin')) {
          settlement = 2;
        }
        this.$api
          .request('Order/create', {type:2, settlement: settlement, client: this.$client, amount: this.amount, payment: this.payment})
          .then(({ data }) => {
            if (data.result == true) {
              this.$message({
                message: "支付成功！",
                type: "success"
              })
            } else if (data.result && data.result.new == true) {
              // 新支付返回结构
              let paymentType = data.result.payment_type || 'link';
              let out_trade_no = data.result.sn || data.result.order_no || '';
              console.log('paymentType:', paymentType)
              switch(paymentType) {
                case 'qrcode':
                  // 显示二维码弹窗
                  this.centerDialogVisible = true;
                  this.downloadData.url = data.result.pay_url || '';
                  if (out_trade_no) {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;
                case 'link':
                    // 打开链接
                    this.openUrl(data.result.pay_url);
                  break;
                case 'jsapi':
                  // jsapi类型：调用微信支付
                  this.wxpay(data.result);
                  break;
                case 'app':
                  // app类型：调用马甲APP支付
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的支付类型！",
                    type: "warning"
                  })
                  break;
              }
            } else {
              // 旧支付返回结构，保持原有逻辑
              let out_trade_no = '';
              switch(this.$client) {
                case 'h5':
                  if (this.payment == 'weixin') {
                    if (data.result.is_wap) {
                      this.openUrl(data.result.h5_url);
                    } else {
                      this.centerDialogVisible = true;
                      this.downloadData.url = data.result.code_url;
                      out_trade_no = data.result.out_trade_no;
                    }
                  } else {
                    switch (data.type) {
                      case "1":
                        if (this.payment == 'gcashpay') {
                          this.openUrl(data.result.data.content);
                        } else {
                          this.centerDialogVisible = true;
                          this.downloadData.url = data.result.data.content;
                          out_trade_no = data.result.data.outTradeNo;
                        }
                        break;
                      case "2":
                        switch (this.payment) {
                          case "alipay":
                            this.centerDialogVisible = true;
                            this.downloadData.url = data.result.results.pay_url;
                            out_trade_no = data.result.results.out_trade_no;
                            break;
                          case "gcashpay":
                            this.openUrl(data.result.results.api_url);
                            break;
                        }
                        break;
                      default:
                        this.$message({
                          message: "暂不支持的支付类型！",
                          type: "warning"
                        })
                        break;
                    }
                  }
                  if (out_trade_no != '') {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;
                case 'wxh5':
                  this.wxpay(data.result);
                  break;
                case 'magapp':
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            }
          })
          .catch(error => {
            this.$message({
              message: error+"下单失败,请联系客服！",
              type: "warning"
            })
          });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      handleRadioChange(e) {
        this.payment = e;
      },
    }
  }
</script>


<style scoped lang="less">
  @import url("../../static/less/mine.less");

  .none {
    display: none !important;
  }

  .info_under .divide-line::after {
    border-right: rgba(0, 0, 0, 0) !important;
  }

  .radio-area {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 30px 0 0 0;
    flex-wrap: wrap;
  }

  .radio-item {
    padding-right: 7px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .btn-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-area .btn {
    padding: 9px 15px;
  }

  .el-dialog {
    border-radius: 4px;
  }

  .dialog {
    .amount-desc {
      // text-align: left;
      margin-bottom: 30px;
      font-size: 13px;
      color: #BD242B;
      letter-spacing: 0.6px;
    }
    /deep/ .el-dialog__body {
      padding: 0 20px;
    }
  }

  .dialog .el-dialog {
    padding-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/page/wallet.vue